// extracted by mini-css-extract-plugin
export default {"globalLoader":"GlobalLoader_globalLoader__X-8J+","globalLoaderWrapper":"GlobalLoader_globalLoaderWrapper__gLpBs"};